import { render, staticRenderFns } from "./projectManage.vue?vue&type=template&id=ed0ca15c&scoped=true&"
import script from "./projectManage.vue?vue&type=script&lang=js&"
export * from "./projectManage.vue?vue&type=script&lang=js&"
import style0 from "./projectManage.vue?vue&type=style&index=0&id=ed0ca15c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0ca15c",
  null
  
)

export default component.exports